import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { LocationResponse } from '../../constants/types'
import { LOCATIONS_URL } from '../../constants/urls'

export const locationsApi = createApi({
  reducerPath: 'locations/api',
  baseQuery: fetchBaseQuery({
    baseUrl: LOCATIONS_URL,
  }),
  tagTypes: ['Location'],
  endpoints: (build) => ({
    getLocations: build.query<LocationResponse[], void>({
      query: () => ({
        url: '',
        credentials: 'include',
      }),
      providesTags: (result, error, arg) =>
        result
          ? [...result.map(({ id }) => ({ type: 'Location' as const, id }))]
          : ['Location'],
    }),
    getLocation: build.mutation<
      LocationResponse[],
      { locationId: number; withPoints?: boolean }
    >({
      query: ({ locationId, withPoints = false }) => ({
        url: '',
        credentials: 'include',
        params: {
          locationId,
          withPoints,
        },
      }),
    }),
  }),
})
